var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-breadcrumb"},[_c('button',{staticClass:"c-breadcrumb__item",on:{"click":function($event){return _vm.$router.go(-1)}}},[_c('span',[_vm._v("Go back")])])])}
var staticRenderFns = []

export { render, staticRenderFns }